import type { ChartBuilderKey, ChartData, ChartDataBuilder, ChartDefinition, ChartResult } from './types';
import type { BuildChartContext } from './types';
import type { ChartId } from './chartCatalog';
import { resolveChartLabels } from '../utils/resolveChartLabels';

function createPassthroughBuilder(): ChartDataBuilder {
  return (
    _definition: ChartDefinition,
    result: ChartResult,
    ctx: BuildChartContext
  ): ChartData => {
    const rawLabels = result.rawData?.labels ?? [];
    const rawTripletLabels = result.rawData?.tripletLabels;

    return {
      values: result.rawData?.values ?? [],
      labels: resolveChartLabels(rawLabels, ctx.intl),
      lineSeries: result.rawData?.lineSeries,
      categories: result.rawData?.categories
        ? resolveChartLabels(result.rawData.categories, ctx.intl)
        : undefined,
      tripletValues: result.rawData?.tripletValues,
      tripletLabels: rawTripletLabels
        ? resolveChartLabels(rawTripletLabels, ctx.intl)
        : undefined,
    };
  };
}

function createBuildersRecord(): Record<ChartBuilderKey, ChartDataBuilder> {
  const builder = createPassthroughBuilder();
  const ids: ChartId[] = [
    'originator',
    'rootCause',
    'impact',
    'environmentalAspect',
    'workType',
    'hsEffect',
    'hazardType',
    'completedInspectionsByTemplate',
    'inspectionEvolution',
    'inspectionTriplet',
    'detectedResolved',
    'resolutionTime',
  ];
  return Object.fromEntries(ids.map((id) => [id, builder])) as Record<
    ChartBuilderKey,
    ChartDataBuilder
  >;
}

export const CHART_BUILDERS: Record<ChartBuilderKey, ChartDataBuilder> =
  createBuildersRecord();

export const CHART_BUILDER_KEYS = Object.keys(CHART_BUILDERS);
